export const MAX_TEXT_BYTES = 128_000;
